import React from "react";
import { Link, useLocation } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  path: string;
}

const Breadcrumb: React.FC = () => {
  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  const generateBreadcrumbs = (): BreadcrumbItem[] => {
    return pathnames.map((value, index) => {
      const path = "/" + pathnames.slice(0, index + 1).join("/");

      return {
        label: value
          .replace("-", " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        path,
      };
    });
  };

  const breadcrumbs = generateBreadcrumbs();

  return (
    <div className="text-sm text-pcg-textMuted flex items-center gap-2">
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <span key={breadcrumb.path} className="flex items-center gap-2">
            {!isLast ? (
              <>
                <Link
                  to={breadcrumb.path}
                  className="hover:underline hover:text-white transition font-sfpro-semibold"
                >
                  {breadcrumb.label}
                </Link>
                <span>{">"}</span>
              </>
            ) : (
              <span className="text-white font-sfpro-semibold">
                {breadcrumb.label}
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
